import React from "react"
import {
  Wrapper,
  NBLInfoContent,
  NBLMiddleInfoContent,
} from "./../../PrintListContent.style"

import { t } from "i18next"
import { ReceiptUpperLimitManagement } from "../../../../types"
import { PRINT_CONFIGURATION_OPTION_VALUES } from "../../../../constants"
import { YearMonth } from "../../common/header/YearMonth"
import { ManagementFacility } from "../../common/header/ManagementFacility"
import { DefaultFormat } from "../body/DefaultFormat"
import { DefaultSheetTitle } from "../header/sheetTitle/DefaultSheetTitle"
import { DefaultChildDetail } from "../header/childDetail/DefaultChildDetail"
import { DefaultUpperMonthLimit } from "../../common/header/upperMonthLimit/DefaultUpperMonthLimit"
import { ShizuokaSignature } from "../../common/footer/signature/ShizuokaSignature"
import { ShizuokaUpperLimitManagementResult } from "../../common/header/upperLimitManagementResult/ShizuokaUpperLimitManagementResult"

type Props = {
  receiptUpperLimitManagement: ReceiptUpperLimitManagement
  printConfig: string[]
}

export function ShizuokaFlame({
  receiptUpperLimitManagement,
  printConfig = [],
}: Props) {
  return (
    <Wrapper>
      {printConfig.includes(
        PRINT_CONFIGURATION_OPTION_VALUES.PRINT_FORM_NUMBER
      ) && <small>{t("(Form 2)")}</small>}

      {/* --- Start Header */}
      <DefaultSheetTitle />
      <YearMonth
        year={receiptUpperLimitManagement.year}
        month={receiptUpperLimitManagement.month}
      />
      <NBLInfoContent length={1}>
        <div className={"top__table_content"}>
          <DefaultChildDetail
            municipalityNumber={receiptUpperLimitManagement.municipality_number}
            receivingCertificateNumber={
              receiptUpperLimitManagement.receiving_certificate_number
            }
            childName={receiptUpperLimitManagement.child_name}
            parentName={receiptUpperLimitManagement.parent_name}
            printConfig={printConfig}
          />
        </div>
        <div className={"top__table_content"}>
          <ManagementFacility
            facilityName={receiptUpperLimitManagement.facility_name}
            facilityNumber={receiptUpperLimitManagement.facility_number}
          />
        </div>
      </NBLInfoContent>
      <NBLMiddleInfoContent>
        <div className={"NBLMiddleInfoContent"}>
          <div className={"nbl_info_top_content"}>
            <DefaultUpperMonthLimit
              burdenMaxMonth={receiptUpperLimitManagement.burden_max_month}
            />
          </div>
          <div className={"nbl_info_bottom_content"}>
            <ShizuokaUpperLimitManagementResult
              managementResult={receiptUpperLimitManagement.management_result}
            />
          </div>
        </div>
      </NBLMiddleInfoContent>
      {/* --- End Header */}

      {/* --- Start Body */}
      <DefaultFormat
        facilities={receiptUpperLimitManagement.facilities}
        totalAmount={receiptUpperLimitManagement.total_amount}
        totalBurdenAmount={receiptUpperLimitManagement.total_burden_amount}
        managementResultBurdenAmount={
          receiptUpperLimitManagement.management_result_burden_amount
        }
      />
      {/* --- End Body */}

      {/* --- Start Footer */}
      <ShizuokaSignature printConfig={printConfig} />
      {/* --- End Footer */}
    </Wrapper>
  )
}
